import Vue from 'vue'
import moment from 'moment'
// 注册日期时间过滤器
Vue.filter('moment', function (value, istime) {
  if (!value) {
    return ''
  }
  if (istime) {
    return moment(value).format('YYYY/MM/DD HH:mm')
  } else {
    return moment(value).format('YYYY-MM-DD')
  }
})
// 工单状态转换
Vue.filter('OrderStutasToText', function (value) {
  switch (value) {
    //   未接单：0；未预约：1；待上门：2；实施中：3;实施审核未通过：4；实施审核通过：5
    case 0:
      return '未接单'
    case 1:
      return '未预约'
    case 2:
      return '待上门'
    case 3:
      return '实施中'
    case 4:
      return '审核未通过'
    case 5:
      return '审核通过'
    default:
      return ''
  }
})
Vue.filter('formatDistance', function (value) {
  if (value > 1000) {
    return (value / 1000).toFixed(1)
  } else if (value > 0 && value < 1000) {
    return value.toFixed(0)
  } else {
    return 0
  }
})
// 性别转换
Vue.filter('sexFilter', function (value) {
  switch (value) {
    case 1:
      return '男'
    default:
      return '女'
  }
})

// 首页带图通知文章前20字
Vue.filter('titleFilter1', function (value) {
  return value.length > 75 ? value.slice(0, 60) + '...' : value
})
// 首页不带图通知文章前20字
Vue.filter('titleFilter2', function (value) {
  return value.length > 20 ? value.slice(0, 20) + '...' : value
})
Vue.filter('Filter', function (value) {
  return value === null || value === '' ? 0 : value
})
// 好评率计算
Vue.filter('praiseRate', function (value, totalReview) {
  if (totalReview === 0) {
    return 0
  }
  return (Number(value / totalReview).toFixed(2) * 100) + '%'
})

// 截取字符串  .substring(0,8)
Vue.filter('substring', function (value) {
  if (value === null || value === '') {
    return ''
  }
  return value.substring(5, 10) + ' ' + value.substring(11, 16)
})

// 分钟转 00:00
Vue.filter('int2time', function (value) {
  try {
    var num = Number(value)
    if (num === 0) {
      return '00:00'
    } else if (num / 60 < 1) {
      if (num >= 10) {
        return num + ':' + '00'
      } else {
        return '0' + num + ':' + '00'
      }
    } else if (num / 60 > 1) {
      if (num % 60 >= 10) {
        return (num / 60) + ':' + (num % 60)
      } else {
        return (num / 60) + ':' + '0' + (num % 60)
      }
    }
  } catch (error) {
    return '00:00'
  }
})

// 秒转 0:00:00
Vue.filter('sToTime', function (value) {
  try {
    let NowtimeValue = Number(value)
    let nowH = parseInt(NowtimeValue / 3600)
    let nowM = parseInt(NowtimeValue % 3600 / 60)
    let nowS = parseInt(NowtimeValue % 60)
    nowH = nowH < 10 ? nowH : nowH
    nowM = nowM < 10 ? nowM = '0' + nowM : nowM
    nowS = nowS < 10 ? nowS = '0' + nowS : nowS
    return nowH + ':' + nowM + ':' + nowS
  } catch (error) {
    return '0:00:00'
  }
})

Vue.filter('paystatus2text', function (value) {
  if (value === null || value === '' || value === undefined) {
    return ''
  }
  if (value === 0) {
    return '待付款'
  }
  if (value === 1) {
    return '待付款'
  }
  if (value === 2) {
    return '待付款'
  }
  if (value === 3) {
    return '待付款'
  }
  if (value === 4) {
    return '待付款'
  }
  return ''
})

// 课程列表截取
Vue.filter('substringdiscrib', function (value) {
  if (value === null || value === '' || value === undefined) {
    return ''
  }
  if (value.length > 26) {
    return value.substring(0, 25) + '...'
  } else {
    return value
  }
})



// WEBPACK FOOTER //
// ./src/utils/vueFilters.js